// Constants

// Support / feedback address (also referenced in public/privacy.html).
export const SUPPORT_EMAIL = 'oliver@taptap.org.uk';
export const WEBSITE_URL = 'https://taptap.org.uk';
// Pro is a real, live subscription (not a waitlist) - this just links to the
// website's pricing section for people who can't buy/start a trial in-app
// right now (e.g. between the trial ending and a fresh entitlement check).
export const PRO_INFO_URL = `${WEBSITE_URL}/?utm_source=taptap-app&utm_medium=product&utm_campaign=pro-info#pro-notify`;

export const COLOR_OPTIONS = {
  blue: { gradient: 'radial-gradient(circle, #1e40af 0%, #3b82f6 70%, #60a5fa 100%)', shadow: 'rgba(59, 130, 246, 0.6)' },
  red: { gradient: 'radial-gradient(circle, #991b1b 0%, #dc2626 70%, #f87171 100%)', shadow: 'rgba(220, 38, 38, 0.6)' },
  green: { gradient: 'radial-gradient(circle, #166534 0%, #16a34a 70%, #4ade80 100%)', shadow: 'rgba(22, 163, 74, 0.6)' },
  purple: { gradient: 'radial-gradient(circle, #581c87 0%, #9333ea 70%, #c084fc 100%)', shadow: 'rgba(147, 51, 234, 0.6)' },
  orange: { gradient: 'radial-gradient(circle, #9a3412 0%, #ea580c 70%, #fb923c 100%)', shadow: 'rgba(234, 88, 12, 0.6)' },
  pink: { gradient: 'radial-gradient(circle, #be185d 0%, #ec4899 70%, #f9a8d4 100%)', shadow: 'rgba(236, 72, 153, 0.6)' },
  cyan: { gradient: 'radial-gradient(circle, #0e7490 0%, #0891b2 70%, #67e8f9 100%)', shadow: 'rgba(8, 145, 178, 0.6)' },
  yellow: { gradient: 'radial-gradient(circle, #a16207 0%, #ca8a04 70%, #fde047 100%)', shadow: 'rgba(202, 138, 4, 0.6)' },
  teal: { gradient: 'radial-gradient(circle, #134e4a 0%, #14b8a6 70%, #5eead4 100%)', shadow: 'rgba(20, 184, 166, 0.6)' },
  indigo: { gradient: 'radial-gradient(circle, #312e81 0%, #6366f1 70%, #a5b4fc 100%)', shadow: 'rgba(99, 102, 241, 0.6)' },
  lime: { gradient: 'radial-gradient(circle, #365314 0%, #65a30d 70%, #bef264 100%)', shadow: 'rgba(101, 163, 13, 0.6)' },
  rose: { gradient: 'radial-gradient(circle, #881337 0%, #e11d48 70%, #fb7185 100%)', shadow: 'rgba(225, 29, 72, 0.6)' },
  amber: { gradient: 'radial-gradient(circle, #92400e 0%, #f59e0b 70%, #fbbf24 100%)', shadow: 'rgba(245, 158, 11, 0.6)' },
  emerald: { gradient: 'radial-gradient(circle, #064e3b 0%, #059669 70%, #34d399 100%)', shadow: 'rgba(5, 150, 105, 0.6)' },
  violet: { gradient: 'radial-gradient(circle, #4c1d95 0%, #8b5cf6 70%, #c4b5fd 100%)', shadow: 'rgba(139, 92, 246, 0.6)' },
  sky: { gradient: 'radial-gradient(circle, #0c4a6e 0%, #0ea5e9 70%, #7dd3fc 100%)', shadow: 'rgba(14, 165, 233, 0.6)' },
  slate: { gradient: 'radial-gradient(circle, #334155 0%, #64748b 70%, #cbd5e1 100%)', shadow: 'rgba(100, 116, 139, 0.6)' },
  multicolor: {
    gradient: 'conic-gradient(from 0deg, #3b82f6, #ec4899, #22c55e, #a855f7, #f97316, #eab308, #06b6d4, #ef4444, #3b82f6)',
    shadow: 'rgba(147, 51, 234, 0.6)'
  }
};

// Free Tap keeps the core branded pair. The wider colour collection is a Pro
// customisation; this list is also used to reset a colour safely if Pro access
// ends while the app is open.
export const FREE_COLOR_KEYS = Object.freeze(['blue', 'purple']);

export const ANIMAL_OPTIONS = {
  cat: { emoji: '🐱', sound: 'meow', color: '#f97316' },
  dog: { emoji: '🐶', sound: 'woof', color: '#eab308' },
  cow: { emoji: '🐄', sound: 'moo', color: '#22c55e' },
  sheep: { emoji: '🐑', sound: 'baa', color: '#f3f4f6' },
  pig: { emoji: '🐷', sound: 'oink', color: '#ec4899' },
  duck: { emoji: '🦆', sound: 'quack', color: '#06b6d4' },
  lion: { emoji: '🦁', sound: 'roar', color: '#f59e0b' },
  elephant: { emoji: '🐘', sound: 'trumpet', color: '#6b7280' },
  frog: { emoji: '🐸', sound: 'ribbit', color: '#16a34a' },
  horse: { emoji: '🐴', sound: 'neigh', color: '#a16207' },
  chicken: { emoji: '🐔', sound: 'cluck', color: '#fbbf24' },
  snake: { emoji: '🐍', sound: 'hiss', color: '#84cc16' },
  owl: { emoji: '🦉', sound: 'hoot', color: '#b45309' },
  monkey: { emoji: '🐵', sound: 'ooh-ooh', color: '#92400e' },
  // Not a real animal: each orb shows a random animal that reshuffles on every
  // reappear (the kids-mode equivalent of the multicolour orb option). The orbs
  // never render this key directly — it resolves to real animals per orb.
  random: { emoji: '🔀', sound: 'shuffle', color: '#a855f7' }
};
